import type { ILoadingOverlayAngularComp } from 'ag-grid-angular';
import type { ILoadingOverlayParams } from 'ag-grid-community';
import { Component } from '@angular/core';
import { NgIf, NgStyle } from '@angular/common';
import { IoniconsOutline } from '@pt/pt-models';
import { IonicModule } from '@ionic/angular';

type CustomLoadingOverlayParams = ILoadingOverlayParams & { loadingMessage: string };
@Component({
  standalone: true,
  template: `
    <div class="ag-overlay-loading-center" role="presentation">
      <button class="btn btn-sm pt-btn-reload" style="
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: space-between;
      " (click)="reloadTable()">
        <ion-icon name='{{IconReload}}' [ngStyle]="{'font-size': '14px'}" class='ion-icon' style="margin-right: 3px;" title=''></ion-icon>
        {{ params.loadingMessage }}
      </button>
    </div>
  `,
  imports: [
    NgIf,
    IonicModule,
    NgStyle
  ]
})
export class CustomLoadingOverlayComponent implements ILoadingOverlayAngularComp {
  public params!: CustomLoadingOverlayParams;
  public IconReload = IoniconsOutline.reload;

  agInit(params: CustomLoadingOverlayParams): void {
    this.refresh(params);
  }

  refresh(params: CustomLoadingOverlayParams): void {
    this.params = params;
  }

  public reloadTable() {
    if (this.params.context) {
      this.params.context.reloadTable()
    }
  }
}
